import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
  title: {
    marginTop: 25,
    // fontWeight: 'bold'
  },
  emptyButton: {
    minWidth: '150px',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '5px',
    },
    [theme.breakpoints.up('xs')]: {
      marginRight: '20px',
    },
  },
  checkoutButton: {
    minWidth: '150px',
  },
  link: {
    textDecoration: 'none',
    color: '#c51162'
  },
  subtotalText: {
    marginBottom: '20px'
  },
  cardDetails: {
    display: 'flex',
    flexDirection: 'column',
    // marginTop: 100,
    // marginBottom: '5%',
    width: '100%',
    justifyContent: 'space-between',
  }
}));